import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MailsDataProvider {
	mailData: BehaviorSubject<any> = new BehaviorSubject(false);
	mailDetailsView: BehaviorSubject<any> = new BehaviorSubject(false);
	mailUpdateEvent: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor(public http: HttpClient) {}

	get mailDataObservable() {
		return this.mailData.asObservable();
	}

	get mailDetailsViewObservable() {
		return this.mailDetailsView.asObservable();
	}

	get shouldMailsBeUpdatedObservable() {
		return this.mailUpdateEvent.asObservable();
	}

	emitMailData(mailData) {
		return this.mailData.next(JSON.parse(JSON.stringify(mailData)));
	}

	emitMailDetailsView(mailData) {
		return this.mailDetailsView.next(JSON.parse(JSON.stringify(mailData)));
	}

	emitMailUpdateEvent(value) {
		this.mailUpdateEvent.next(value);
	}

	sendEmail(data, mailId, jobId?: number, leadId?: number) {
		let url;
		if (leadId) {
			url = `/api/user/lead/${leadId}/send/${mailId}/`;
		} else {
			url = `/protected/rest/clients/send/${mailId}/`;
			url += jobId || '';
		}

		const { sendMessageData, storedFiles, uploadedFiles } = data;

		const formData: FormData = new FormData();

		for (const key in sendMessageData) {
			if (key !== 'attachmentsData') {
				formData.append(key, sendMessageData[key]);
			}
		}

		for (const key in storedFiles) {
			formData.append(`storedAttachments[${key}]`, storedFiles[key].id);
		}

		for (const key in uploadedFiles) {
			formData.append(`attachments[${key}]`, uploadedFiles[key]);
		}

		return this.http.post(url, formData);
	}

	getMailDetailsView(jobMailId) {
		const url = `/protected/rest/jobs/job/mail/?id=${jobMailId}`;
		return this.http.get(url);
	}

	getJobMails(jobId: number, syncReply: boolean): Observable<Object> {
		const url = `/api/user/v1/job/${jobId}/mail?forceSyncReplies=${syncReply}`;

		return this.http.get(url);
	}

	getContactMails(contactId: number, syncReply: boolean): Observable<Object> {
		const url = `/api/user/v1/contact/${contactId}/mail?forceSyncReplies=${syncReply}`;

		return this.http.get(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/email/mails.data.service.ts